import { render, staticRenderFns } from "./RelatedLinks.vue?vue&type=template&id=4fbaf6ed&scoped=true&"
import script from "./RelatedLinks.vue?vue&type=script&lang=js&"
export * from "./RelatedLinks.vue?vue&type=script&lang=js&"
import style0 from "./RelatedLinks.vue?vue&type=style&index=0&id=4fbaf6ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbaf6ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HybridLink: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/HybridLink/HybridLink.vue').default})
